var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      position: "relative"
    },
    style: {
      "--color": _vm.themeColor
    },
    on: {
      click: function ($event) {
        return _vm.$emit("itemClick");
      }
    }
  }, [_vm.pageType == "DETAILS" ? _c("top-title", {
    attrs: {
      themeColor: _vm.themeColor
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("我要投保")))])]) : _vm._e(), _c("div", [_vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index + 2,
      staticClass: "listBox",
      class: _vm.styleObj.controlsComponentsMark == "information2" ? "listBox2" : ""
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "list"
    }, _vm._l(item.list, function (item2, index2) {
      return _c("div", {
        key: index2 + 1
      }, [_c("div", [_vm._v(_vm._s(_vm.$t(item2.name)))])]);
    }), 0)]);
  }), _vm.styleObj.isAddInsured ? _c("div", {
    staticClass: "add",
    class: _vm.styleObj.controlsComponentsMark == "information2" ? "add2" : ""
  }, [_vm._v(" + " + _vm._s(_vm.$t("添加被保人")) + " ")]) : _vm._e(), _vm._l(_vm.arr, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "listBox",
      class: _vm.styleObj.controlsComponentsMark == "information2" ? "listBox2" : ""
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "list"
    }, _vm._l(item.list, function (item2, index2) {
      return _c("div", {
        key: index2 + 3
      }, [_c("div", [_vm._v(_vm._s(_vm.$t(item2.name)))])]);
    }), 0)]);
  })], 2), !_vm.styleObj.isHiddenClause ? _c("div", {
    staticClass: "clauseBox"
  }, [_c("span", {
    staticClass: "circle",
    style: " border:1px solid " + _vm.styleObj.clauseColor
  }), _vm._v(" " + _vm._s(_vm.$t("本人已认真阅读"))), _c("span", {
    style: "color:" + _vm.styleObj.clauseColor
  }, [_vm._v("《" + _vm._s(_vm.$t("投保须知")) + "》、《" + _vm._s(_vm.$t("保险条款")) + "》、《" + _vm._s(_vm.$t("投保声明")) + "》")]), _vm._v("，" + _vm._s(_vm.$t("且全面知晓理解相关内容，并予以同意")) + "。 ")]) : _vm._e(), _c("div", [_vm._t("edit")], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };